import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetManufacturers = ():{ manufacturers: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelValuePair[], AxiosError>('/marker/getManufacturers',
    (url) => fetcher(url));

  return {
    manufacturers: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetManufacturers;
